export const setValuesInFmlString =(setSelectedState,className) =>{
    let mothersClass=document.getElementsByClassName(className);
    for(let i=0;i<mothersClass.length;i++)
    {
      let stringWithoutSpaces = mothersClass[i].value.replace(/\s/g, '');
      setSelectedState(prevFML=>prevFML+ ' ' +stringWithoutSpaces);
    }
}